import { memo } from 'react';
import { Text } from 'Text';

function LogoBoxDescriptionComponent({ children }: { children: React.ReactNode }) {
    return (
        <Text as="div" color="slate-grey" weight="normal" className="text-base">
            {children}
        </Text>
    );
}

export const LogoBoxDescription = memo(LogoBoxDescriptionComponent) as typeof LogoBoxDescriptionComponent;
